
const _getLocalStore = (name) => {
	try {
		return JSON.parse(localStorage.getItem(name));
	} catch (err) {
		return null;
	}
};

const CurrencyChecker = (session) => {
	let currency = 'INR';
	const localStoreCurrency = _getLocalStore('currentCurrency');
	if (localStoreCurrency) {
		currency = localStoreCurrency;
	} else if (session.currentCurrency) {
		currency = session.currentCurrency;
	} else if (session.country) {
		currency = session.country;
	}
	if (currency === 'INR' || currency === 'IN') {
		return 'INR';
	}
	return 'USD';
};

export default CurrencyChecker;
